export const traitCategories: string[] =
  process.env.REACT_APP_TRAIT_CATEGORIES!.split(",");

export const traitCategoriesRanges: number[] = process.env
  .REACT_APP_TRAIT_CATEGORIES_RANGES!.split(",")
  .map((range) => parseInt(range, 10));

export const swapableTraitCategories: string[] =
  process.env.REACT_APP_SWAPABLE_TRAIT_CATEGORIES!.split(",");

export const traitRangesByCategory: {
  [key: string]: [from: number, to: number];
} = traitCategories.reduce((acc, category, index) => {
  const rangeStartAt = traitCategoriesRanges[index];

  return {
    ...acc,
    [category]: [rangeStartAt + 1, rangeStartAt + 1000 - 1],
  };
}, {});
